import React from 'react';
import { PrivateLayout, PV_THEME } from '../PrivateLayout';

const T = PV_THEME;

const FRAUD = [
  { k: 'Photo-swap attacks', v: 'Auction listing photo replaced post-bid remains the dominant fraud vector — ~38% of dispute cases originate here.' },
  { k: 'Wire-redirect (BEC)', v: 'Attacks on gallery payments increased 142% Q1→Q4 2025. Mitigated by escrow IBANs being non-displayed.' },
  { k: 'Synthetic identity', v: 'Attempts on collector onboarding have plateaued since Sumsub liveness mandates were tightened.' },
];

const PRICING = [
  { k: '£25K–£100K settlement-to-listing', v: 'Average ratio 0.87 — realised price typically 13% below original listing.' },
  { k: 'Cross-border deals', v: '22-day average settlement vs. 9 days domestic.' },
  { k: 'KYC-cleared buyer lists', v: 'Galleries with cleared buyer lists close 2.3× faster than those without.' },
];

const SEGMENTS = [
  { k: 'Fastest-growing artist segment', v: 'Post-2015 European art school graduates working in mixed media at the £5K–£25K band. Up 71% YoY.' },
  { k: 'Collectors 28–38', v: 'Now account for 34% of verified buyers, up from 18% two years ago.' },
  { k: 'Geographic shift', v: 'Online sales to first-time buyers reached 46% — increasingly cross-border, increasingly under-banked.' },
];

function Group({ title, items, color, num }) {
  return (
    <section className="relative z-10 max-w-[1100px] mx-auto px-4 sm:px-6 lg:px-8 pb-16">
      <div className="font-mono uppercase mb-1" style={{ fontSize: 9, letterSpacing: '0.3em', color: T.textFaint }}>
        §{num}
      </div>
      <div className="flex items-center gap-4 mb-8">
        <h2 className="font-machina font-bold uppercase" style={{ fontSize: 22, letterSpacing: '0.15em', color }}>{title}</h2>
        <div className="h-px flex-1" style={{ background: `linear-gradient(to right, ${color}66, transparent)` }} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {items.map((it) => (
          <div
            key={it.k}
            className="rounded-[6px] p-5 transition-colors relative overflow-hidden"
            style={{ background: T.surface, border: `1px solid ${T.border}` }}
          >
            <div className="absolute top-0 left-0 h-full w-0.5" style={{ background: color }} />
            <h3 className="font-machina font-bold uppercase mb-3" style={{ fontSize: 13, letterSpacing: '0.1em', color: T.text }}>
              {it.k}
            </h3>
            <p className="font-sans leading-[1.7]" style={{ fontSize: 12, color: T.textMuted }}>{it.v}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default function MarketIntelSection() {
  return (
    <PrivateLayout eyebrowLabel="Market Intel" testid="pv-intel">
      <section className="relative z-10 max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-12">
        <p className="font-mono uppercase mb-4" style={{ fontSize: 10, letterSpacing: '0.4em', color: T.red }}>
          [ .VI. .MARKET.INTEL. ]
        </p>
        <h1 className="font-machina font-bold uppercase mb-6" style={{ fontSize: 'clamp(32px,6vw,56px)', lineHeight: 0.95, color: T.text }}>
          What we see<br />that you do not.
        </h1>
        <p className="font-mono leading-[1.8] max-w-2xl" style={{ fontSize: 13, color: T.textMuted }}>
          Operating across thousands of escrowed transactions gives us a unique lens on the art market. A selection of what the data tells us.
        </p>
      </section>

      <Group num="1" title="Fraud patterns" color={T.red} items={FRAUD} />
      <Group num="2" title="Pricing signals" color={T.accent} items={PRICING} />
      <Group num="3" title="Segment trends" color={T.green} items={SEGMENTS} />

      <section className="relative z-10 max-w-[900px] mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div
          className="rounded-[6px] p-8 text-center"
          style={{ background: T.surface, border: `1px solid ${T.red}33` }}
        >
          <div className="font-mono uppercase mb-3" style={{ fontSize: 10, letterSpacing: '0.3em', color: T.red }}>
            Subscribe
          </div>
          <h3 className="font-machina font-bold uppercase mb-3" style={{ fontSize: 20, color: T.text }}>
            Quarterly Intel Briefing
          </h3>
          <p className="font-mono mb-6 max-w-md mx-auto leading-[1.7]" style={{ fontSize: 12, color: T.textMuted }}>
            Sent to verified investor and operator subscribers. Request access via intel@trustframe.legal.
          </p>
          <a
            href="mailto:intel@trustframe.legal?subject=Quarterly%20Intel%20briefing"
            data-testid="intel-subscribe"
            className="inline-flex items-center gap-2 px-6 py-3 font-machina font-bold uppercase transition-opacity hover:opacity-90"
            style={{ background: T.red, color: '#0a0a0b', fontSize: 11, letterSpacing: '0.3em' }}
          >
            Request access
          </a>
        </div>
      </section>
    </PrivateLayout>
  );
}
